module.exports = __webpack_public_path__ + "img/delete-fill-disable.a81e0d56.svg";